import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { apiClient } from "../utils/apiClient";

// 各コンポーネントのインポート
import Menu from "./Menu";
import WorkLogEntry from "./WorkLogEntry";
import WorkLogList from "./WorkLogList";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import AdminRoute from "./AdminRoute";
import UserMaintenance from "./UserMaintenance";
import CategoryMaintenance from "./CategoryMaintenance";
import ProjectMaintenance from "./ProjectMaintenance";
import AdminMenu from "./AdminMenu";
import WorkLogExport from "./WorkLogExport";
import AuditLogExport from "./AuditLogExport";
import ClosingMaintenance from "./ClosingMaintenance";
import { User } from "../types";

const App = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  // アプリ起動時に「今ログインしているか？」をサーバーに問い合わせる
  useEffect(() => {
    apiClient
      .get<User>("/api/users/me")
      .then((data) => {
        setUser(data);
      })
      .catch(() => {
        // ログインしていない(401)などのエラー時はここに来る
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  // ロード中は真っ白またはローディング表示にする
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* ログイン画面は誰でも見れる */}
      <Route path="/login" element={<Login />} />

      {/* PrivateRoute で守られたエリア（ログイン必須） */}
      <Route element={<PrivateRoute user={user} />}>
        <Route path="/" element={<Menu />} />

        {/* 業務報告機能 */}
        <Route path="/entry" element={<WorkLogEntry />} />
        <Route path="/list" element={<WorkLogList />} />

        {/* 管理者メニュー */}
        <Route element={<AdminRoute user={user} />}>
          <Route path="/admin" element={<AdminMenu />} />
          <Route path="/users" element={<UserMaintenance />} />
          <Route path="/categories" element={<CategoryMaintenance />} />
          <Route path="/projects" element={<ProjectMaintenance />} />
          <Route path="/admin/export" element={<WorkLogExport />} />
          <Route path="/admin/audit_export" element={<AuditLogExport />} />
          <Route path="/admin/closing" element={<ClosingMaintenance />} />
        </Route>
      </Route>

      {/* 存在しないURLへのアクセスはホームへ戻す */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
